import { AuthGuard } from 'guards/AuthGuard';

export const withAuthGuard = (Component) => {
  const WithAuthGuard = (props) => (
    <AuthGuard>
      <Component {...props} />
    </AuthGuard>
  );

  WithAuthGuard.displayName = `WithAuthGuard(${
    Component.displayName || Component.name || 'Component'
  })`;

  return WithAuthGuard;
};
